import type { Directive, DirectiveBinding } from 'vue'

import { usePermissionsStore } from '@/stores/permissions.store'

type CanValue = string | string[]

interface CanModifiers {
  /** Si está presente, deshabilita el elemento en vez de ocultarlo. */
  disable?: boolean
}

function evaluate(value: CanValue): boolean {
  const permissions = usePermissionsStore()
  const tokens = Array.isArray(value) ? value : [value]
  return tokens.every((token) => {
    const [resource, action] = token.split('.')
    if (!resource || !action) return false
    return permissions.can(action, resource)
  })
}

function apply(el: HTMLElement, binding: DirectiveBinding<CanValue>): void {
  const allowed = evaluate(binding.value)
  const modifiers = binding.modifiers as CanModifiers

  if (modifiers.disable) {
    if (allowed) {
      el.removeAttribute('disabled')
      el.classList.remove('opacity-50', 'pointer-events-none')
    } else {
      el.setAttribute('disabled', 'true')
      el.classList.add('opacity-50', 'pointer-events-none')
    }
    return
  }

  el.style.display = allowed ? '' : 'none'
}

/**
 * v-can="'users.create'"            → oculta si no tiene permiso
 * v-can="['users.update','users.read']" → exige TODOS los permisos
 * v-can.disable="'users.delete'"    → deshabilita en vez de ocultar
 */
export const vCan: Directive<HTMLElement, CanValue> = {
  mounted: apply,
  updated: apply,
}
